import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AirportComment } from '../models/airport-comment.model';
import { RemarkService } from '../service/remark.service';
var EditRemarkComponent = /** @class */ (function () {
    function EditRemarkComponent(_matDialogRef, _snackBar, data, _remarkService) {
        this._matDialogRef = _matDialogRef;
        this._snackBar = _snackBar;
        this._remarkService = _remarkService;
        this.isNew = false;
        this.isLoading = false;
        this.windowTitle = 'Remark';
        this.remark = data.remark || new AirportComment();
        this.isNew = data.isNew || false;
        this.airportID = data.airID;
        this.originalRemark = Object.assign(new AirportComment(), data.remark);
        this.itemsToChange = new Set();
        this.remarkType = AirportComment.formatCommentType(this.remark.commentType);
        this.remarkRef = this.remark.commentRef;
        this.selectedText = this.remark.text ? this.remark.text : '';
        this.windowTitle = data.windowTitle || 'Remark';
    }
    EditRemarkComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._matDialogRef.backdropClick().subscribe(function () {
            _this.close({ cancelBtnClicked: true });
        });
        this.formGroup = new FormGroup({
            text: new FormControl(this.selectedText, [Validators.required, Validators.maxLength(1000)])
        });
    };
    /**
     * triggered by save button click event
     * @return {Promise<void>}
     */
    EditRemarkComponent.prototype.save = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var res, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        res = void 0;
                        this.remark.commentType = AirportComment.parseCommentType(this.remarkType);
                        this.remark.commentRef = this.remarkRef;
                        this.remark.text = this.formGroup.get('text').value;
                        if (!this.isNew) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._remarkService.postRemark(this.airportID, this.remark)];
                    case 1:
                        res = _a.sent();
                        this.remark = AirportComment.parse(res);
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this._remarkService.putRemark(this.airportID, this.remark)];
                    case 3:
                        res = _a.sent();
                        Object.assign(this.remark, AirportComment.parse(res));
                        this.remark = AirportComment.parse(res);
                        _a.label = 4;
                    case 4:
                        this.close({ cancelBtnClicked: false, success: true, remark: this.remark });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.close({ cancelBtnClicked: false, success: false });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * triggered by cancel button click event
     */
    EditRemarkComponent.prototype.cancel = function () {
        this.close({ cancelBtnClicked: true });
    };
    /**
     * closes modal
     * @param data
     */
    EditRemarkComponent.prototype.close = function (data) {
        if (data && data.cancelBtnClicked) {
            Object.assign(this.remark, this.originalRemark);
        }
        data['isNew'] = this.isNew;
        this._matDialogRef.close(data);
    };
    return EditRemarkComponent;
}());
export { EditRemarkComponent };
